import { render, staticRenderFns } from "./ConfirmedScreen.vue?vue&type=template&id=6d8f109f&scoped=true"
import script from "./ConfirmedScreen.vue?vue&type=script&lang=js"
export * from "./ConfirmedScreen.vue?vue&type=script&lang=js"
import style0 from "./ConfirmedScreen.vue?vue&type=style&index=0&id=6d8f109f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f109f",
  null
  
)

export default component.exports